export default ($stateProvider) => {
  $stateProvider
    .state('legacy-reset', {
      url: `${location.pathname}legacy-reset?user`,
      template: '<nets-legacy-reset></nets-legacy-reset>',
    });
};
